import Request from "./AxiosInstance";


export async function DownloadPDF(procedureId) {
	const pdfLink = await Request.post('/api/capsule/pdf', {
		procedureId
	});
	window.open(pdfLink, '_blank');
}